export default "__VITE_ASSET__CymD_Ngx__"